import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Advice, Text } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "./styles/advice.styles";
const useStyles = createUseStyles(styles, 'AdviceRelatedFields');
const AdviceRelatedFields = _ref => {
  let {
    fields
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const keys = Object.keys(fields);
  return /*#__PURE__*/React.createElement(Advice, {
    className: classes.root,
    title: /*#__PURE__*/React.createElement(Text, {
      className: classes.adviceTitle,
      bold: true
    }, t('cfm_label_related_entities')),
    showIcon: true,
    type: "info"
  }, keys.map((key, index) => /*#__PURE__*/React.createElement("div", {
    key: key,
    className: classes.entity
  }, index > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Text, {
    className: classes.entityTitle,
    bold: true
  }, key), fields[key].map(field => /*#__PURE__*/React.createElement(Text, {
    key: field,
    className: classes.field
  }, t(field))))));
};
process.env.NODE_ENV !== "production" ? AdviceRelatedFields.propTypes = {
  fields: PropTypes.object
} : void 0;
export default /*#__PURE__*/memo(AdviceRelatedFields);